/**
 * These are the image sizes that we are willing to render. By using a set of fixed sizes we
 * avoid bloating the image cache ( locally and on the CDN ) and increase the changes of
 * cache hits on the client or other public caches
 */
var BUCKETS = [100, 150, 200, 300, 400, 600, 800, 1000, 1200];
/**
 * the default pixel densities we support
 */

var SUPPORTED_DENSITIES = [1, 2];
/**
 * CDN base URL
 */

var CDN_BASE = 'https://img.cdn4dd.com/p/';

export { BUCKETS, CDN_BASE, SUPPORTED_DENSITIES };
